import {
	Button,
	DateInput,
	Dialog,
	Dropzone,
	SelectFilter,
} from 'src/components';
import {
	CircularProgress,
	FormHelperText,
	Grid,
	MenuItem,
} from '@material-ui/core';
import { IInstitution } from 'src/models';
import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import DownloadIcon from '@material-ui/icons/CloudDownloadRounded';
import moment from 'moment';
import useStyles from './LayoutUploadDialog.-styles';
import userActions from 'src/store/Users/actions';

interface Props {
	open: boolean;
	handleOpen: () => void;
}

function LayoutUploadDialog({ handleOpen, open }: Props) {
	const classes = useStyles();
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const institutions = useSelector(
		(state: RootState) => state.institutions.institutions,
	);
	const isDownloading = useSelector(
		(state: RootState) => state.users.isDownloadingLayout,
	);
	const isUploading = useSelector(
		(state: RootState) => state.users.isUploadingBulk,
	);
	const bulkUpload = (formData: FormData) =>
		dispatch(userActions.bulkUpload(formData));
	const downloadLayout = () => dispatch(userActions.downloadLayout());
	const [institutionId, setInstitutionId] = useState('0');
	const [file, setFile] = useState<any>();
	const [expiresAt, setExpiresAt] = useState(null);

	function handleUpload() {
		const form = new FormData();
		form.append('file', file);
		form.append('institutionId', institutionId);
		form.append(
			'expiresAt',
			expiresAt
				? moment(expiresAt).format('YYYY/MM/DD')
				: moment(new Date()).days(30).format('YYYY/MM/DD'),
		);
		bulkUpload(form);
	}

	useEffect(() => {
		if (!open) {
			setExpiresAt(null);
		}
	}, [open]);

	return (
		<Dialog
			actions={
				<div className={classes.actions}>
					<Button
						backgroundColor={'white'}
						disabled={isDownloading}
						onClick={downloadLayout}
						startIcon={<DownloadIcon />}
					>
						{isDownloading ? (
							<CircularProgress size={26} />
						) : (
							'Descargar Formato'
						)}
					</Button>

					<Button
						actionType={'save'}
						disabled={isUploading}
						onClick={handleUpload}
					>
						{isUploading ? (
							<CircularProgress size={26} />
						) : (
							'Cargar archivo'
						)}
					</Button>
				</div>
			}
			content={
				<Grid container spacing={2}>
					{/* <Grid item xs={12}>
                        <SelectFilter
                            value={institutionId}
                            label="Institution"
                            handleChange={(event: ChangeEvent<HTMLInputElement>) => setInstitutionId(event.target.value)}
                        >
                            <MenuItem value={0}> Sin institución </MenuItem>
                            {institutions.map((institution: IInstitution) => <MenuItem key={institution.id} value={institution.id}> {institution.name} </MenuItem>)}
                        </SelectFilter>
                    </Grid> */}
					<Grid item md={4} xs={12}>
						<DateInput
							label={'Expiración de cursos'}
							name={'expiresAt'}
							onChange={(e: any) => {
								setExpiresAt(e.target.value);
							}}
							value={expiresAt}
						/>

						<FormHelperText>
							{' '}
							Si se envía vacío la expiración es en 30 días{' '}
						</FormHelperText>
					</Grid>

					<Grid item xs={12}>
						<Dropzone
							disabled={isUploading}
							onUpload={(files: any[]) => {
								setFile(files[0]);
							}}
						/>
					</Grid>
				</Grid>
			}
			fullScreen={window.innerWidth <= 960}
			handleOpen={handleOpen}
			maxWidth={'md'}
			open={open}
			title={'Carga por layout'}
		/>
	);
}

export default LayoutUploadDialog;
